export default "__VITE_ASSET__GVABHuGh__"